import React from 'react'
import i18n from 'i18next'
import Headline from '#components/a/Headline'
import Text from '#components/a/Text'
import PageHeader from '#components/m/PageHeader'
import ChatMasterDetail from '#components/o/Chat/ChatMasterDetail'
import CreateChatModal from '#components/o/Chat/CreateChatModal'
import Loading from '#components/a/Loading'
import {useMyChats} from '#hooks/useMyChats'
import {usePermissions} from '#hooks/usePermissions'

function Chat() {
  const {chats} = useMyChats()
  const permissions = usePermissions()

  const canCreateChat = permissions.chat.createOrRename
  const showLoading = chats === null
  const showPlaceholder = chats !== null && Object.keys(chats).length === 0
  const showContent = chats !== null && Object.keys(chats).length > 0
  const placeholderKey = canCreateChat ? 'chats_no_conversations_can_create_chat' : 'chats_no_conversations'

  return (
    <div className="chat-overview">
      <PageHeader
        headline={<Headline importance={1} modifier="section" text={i18n.t('chats')} />}
        button={canCreateChat && <CreateChatModal />}
      />
      {showLoading && <Loading />}
      {showPlaceholder && <Text text={i18n.t(placeholderKey)} />}
      {showContent && <ChatMasterDetail />}
    </div>
  )
}

export default Chat
